import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { HrFlexContainer, HrGrey, HrlighterGrey } from '@components/styles/hr-styles';
import { CounterCard } from '@components/counter/counter';

const Container = styled(HrFlexContainer)`
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap;

  &::-webkit-scrollbar-thumb {
    background: ${HrlighterGrey};
    border-radius: 10px;
    &:hover {
      background-color: ${HrGrey};
    }
  }
  &::-webkit-scrollbar,
  &::-webkit-scrollbar-thumb {
    height: 6px;
    border-radius: 6px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 0px;
    background: transparent;
  }
`;

export const CountersSecctions = ({ data, isLoading }) => {
  const [t] = useTranslation();

  return (
    <Container>
      <CounterCard
        title={t('requestVacancies.colaborativeSelection.counterCards.total')}
        number={data?.total ?? 0}
        isLoading={isLoading}
      />
      <CounterCard
        title={t('requestVacancies.colaborativeSelection.counterCards.pending')}
        number={data?.pending ?? 0}
        isLoading={isLoading}
      />
      <CounterCard
        title={t('requestVacancies.colaborativeSelection.counterCards.approved')}
        number={data?.approved ?? 0}
        isLoading={isLoading}
      />
      <CounterCard
        title={t('requestVacancies.colaborativeSelection.counterCards.rejected')}
        number={data?.rejected ?? 0}
        isLoading={isLoading}
      />
      <CounterCard
        title={t('requestVacancies.colaborativeSelection.counterCards.modified')}
        number={data?.modified ?? 0}
        isLoading={isLoading}
      />
    </Container>
  );
};
